import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { KYMW4502Model } from '../kymw4502.model';

// レスポンス構造
export type GetMediumListForFeatureCopyResponse = {
  MediumList: {
    CanCopy: string;
    MediumType: string;
    MediumName: string;
  }[]
};

/**
 * 特集コピー用媒体一覧取得
 *
 * @export GetMediumListForFeatureCopyService
 * @class GetMediumListForFeatureCopyService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetMediumListForFeatureCopyService extends PlessJsonResponderSub<GetMediumListForFeatureCopyResponse> {
  private vo = {
    copyToOrderCode: '',
    copyFromOrderCode: '',
  };
  private successFunc: Function;
  private model: KYMW4502Model;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetMediumListForFeatureCopyService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      search: {
        searchCanCopyMediumList: {
          condition :{
            CopyToOrderCode: this.vo.copyToOrderCode,
            CopyFromOrderCode: this.vo.copyFromOrderCode
          }
        }
      },
    });
  }

  /**
   * API呼び出し
   * @param vo 
   * @param successFunc
   * @memberof GetMediumListForFeatureCopyService
   */
  execute(vo: any, model: KYMW4502Model, successFunc: Function = null): void {
    this.vo = vo;
    this.model = model;
    this.successFunc = successFunc;
    this.send('getMediumListForFeatureCopy', this.getBody());
  }

  /**
   * API通信成功時の処理
   * @param data レスポンスデータ
   * @memberof GetMediumListForFeatureCopyService
   */
  success(data: GetMediumListForFeatureCopyResponse) {
    this.model.setMediumListForFeatureCopyList(data);
    if (this.successFunc) this.successFunc();
  }
}
